import jwt_decode from 'jwt-decode';

const extractUserIdFromAuthorizationHeader = (headers) => {
    var _a;
    try {
        const authorizationHeader = (_a = headers['Authorization']) !== null && _a !== void 0 ? _a : headers['authorization'];
        if (!authorizationHeader) {
            return undefined;
        }
        const authorizationHeaderParts = authorizationHeader.split(' ');
        if (authorizationHeaderParts.length !== 2) {
            return undefined;
        }
        const authorizationType = authorizationHeaderParts[0];
        if (authorizationType !== 'Bearer') {
            return undefined;
        }
        const authorizationToken = authorizationHeaderParts[1];
        if (!authorizationToken) {
            return undefined;
        }
        const jwtDecoded = jwt_decode(authorizationToken);
        if (typeof jwtDecoded === 'object') {
            return jwtDecoded['https://api.landr.com/nameid'];
        }
        return undefined;
    }
    catch (e) {
        // Failed silently, we need to be fail safe
        return undefined;
    }
};

export { extractUserIdFromAuthorizationHeader };
